import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import totalDriverIcon from 'packages/novous_web/src/assets/icons/DriverCoaching.svg';
import activeDriverIcon from 'packages/novous_web/src/assets/icons/DriversPerformanceReportsIcon.svg';
import availableDriverIcon from 'packages/novous_web/src/assets/icons/route.svg';
import highAlert from 'packages/novous_web/src/assets/icons/map.svg';
import infoIcon from 'packages/novous_web/src/assets/icons/i.svg';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { IconButton } from '@mui/material';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import PermissionGuard from 'packages/novous_web/src/common/components/PermissionGuard';
import { PermissionCategory, PermissionSubcategory } from 'packages/novous_web/src/utils/permissionConstants';

const DriverAlertDataDashboardTiles = ({ dateState, driverId }: any) => {
  let driverTilesData = [
    {
      icon: totalDriverIcon,
      heading: 'Coaching In-Progress',
      value: '0',
      permission: {
        category: PermissionCategory.ALERTS,
        subcategory: PermissionSubcategory.DRIVER_ALERTS,
      },
    },
    {
      icon: activeDriverIcon,
      heading: 'Driver Score',
      value: '0',
      permission: {
        category: PermissionCategory.ALERTS,
        subcategory: PermissionSubcategory.DRIVER_ALERTS,
      },
    },
    {
      icon: availableDriverIcon,
      heading: 'Total Driven KM',
      value: '0',
      permission: {
        category: PermissionCategory.ALERTS,
        subcategory: PermissionSubcategory.DRIVER_ALERTS,
      },
    },
    {
      icon: highAlert,
      heading: 'Total Trips',
      value: '0',
      permission: {
        category: PermissionCategory.ALERTS,
        subcategory: PermissionSubcategory.DRIVER_ALERTS,
      },
    },
  ];

  const { user } = useAuth();
  const {
    data: driverData,
    error: driverError,
    loading: driverLoading,
    fetchData: fetchDriverData,
  } = useAxios<any>(`${API_ENDPOINTS.alarm.GET_DRIVER_ALERT_COUNT}`, 'POST');

  useEffect(() => {
    if (user?.customer_id) {
      fetchDriverData({
        fleetId: user?.customer_id,
        driverId: driverId,
        startDate: dateState?.startDate,
        endDate: dateState?.endDate,
      });
    }
  }, [user]);

  driverTilesData[0].value = driverData?.data.coachingInProgress || 0;
  driverTilesData[1].value = driverData?.data.totalDriverScore || 0;
  driverTilesData[2].value = driverData?.data.totalKms || 0;
  driverTilesData[3].value = driverData?.data.totalTrips || 0;

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {driverTilesData.map((tile, index) => (
        <PermissionGuard
          key={index}
          category={tile.permission.category}
          subcategory={tile.permission.subcategory}
        >
          <Paper
            sx={{ borderRadius: '12px' }}
            className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
          >
            <div className="flex items-center gap-2 w-full">
              <IconButton
                sx={(theme) => ({
                  background: theme.palette.selected,
                  padding: '4px',
                })}
              >
                <img src={tile.icon} alt="icon" color="primary" />
              </IconButton>
              <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                <Typography
                  variant="button"
                  fontWeight={400}
                  noWrap
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%',
                  }}
                >
                  {tile.heading}
                </Typography>
              </div>

              <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
            </div>
            <div className="flex items-center w-full gap-2 flex-nowrap">
              <div className="invisible w-6 h-6">{tile.icon}</div>
              <Typography
                variant="h6"
                fontWeight={600}
                className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
              >
                {tile.value}
              </Typography>
            </div>
          </Paper>
        </PermissionGuard>
      ))}
    </div>
  );
};

export default DriverAlertDataDashboardTiles;
